import {Component, effect, input, signal, ChangeDetectionStrategy} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {environment} from '@env/environment';
import {captureException} from '@sentry/angular';
import {customImageLoader} from '../../../../../../../custom-image-loader';

// TODO: Remove this type extension once backend GraphQL schema is updated with highlightText field
interface WineProductWithHighlight extends WineProduct {
  highlightText?: string | null;
}

@Component({
  selector: 'app-product-highlight-section',
  templateUrl: './product-highlight-section.component.html',
  styleUrls: ['./product-highlight-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ProductHighlightSectionComponent {

  formattedHighlightText = signal<string>('');

  product = input<WineProductWithHighlight | undefined>();

  constructor() {
    effect(() => {
      const product = this.product();
      if (product?.highlightText) {
        this.formattedHighlightText.set(this.domParser(product.highlightText));
      } else {
        this.formattedHighlightText.set('');
      }
    });
  }

  onImageError(src: string) {
    captureException('IMAGE_NOT_FOUND', {
      extra: {
        src
      }
    });
  }

  private domParser(htmlContent: string): string {
    if (typeof document === 'undefined') {
      return htmlContent;
    }
    let div = document.createElement('div');
    div.innerHTML = htmlContent;

    div = this.imageParser(div);
    div = this.vimeoParser(div);

    return new XMLSerializer().serializeToString(div);
  }

  private imageParser(div: HTMLDivElement): HTMLDivElement {
    Array.from(div.getElementsByTagName('img')).forEach((value) => {
      let path: string | null = value.getAttribute('src');
      if (!path) {
        return;
      }

      if (path.indexOf('/pub/media/') === 0) {
        path = environment.supervin.assets + path;
      }

      const url = customImageLoader({
        width: 500,
        src: path
      });
      value.setAttribute('src', url);
      value.setAttribute('loading', 'lazy');
      value.onerror = () => this.onImageError(url);
    });

    return div;
  }

  private vimeoParser(div: HTMLDivElement): HTMLDivElement {
    Array.from(div.querySelectorAll('div[data-video-src]')).forEach((value) => {
      const child = document.createElement('div');
      child.setAttribute('class', 'vimeo');

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://player.vimeo.com/video/${value.getAttribute('data-video-src')}`);
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('frameborder', '0');

      child.appendChild(iframe);
      value.replaceWith(child);
    });

    return div;
  }
}
